// @ts-strict-ignore
import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-dots-loader',
    templateUrl: './dots-loader.component.html',
    styleUrls: ['./dots-loader.component.scss'],
    standalone: false
})
export class DotsLoaderComponent {
  @Input() color: string;
  @Input() halfSize = false;

  public backgroundColor: string = `background-color: ${DotsColour['green']};`;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.color) {
      if (changes.color.currentValue) {
        this.backgroundColor = `background-color: ${DotsColour[this.color]};`;
      } else {
        this.backgroundColor = `background-color: ${DotsColour['green']};`;
      }
    }
  }
}

export enum DotsColour {
  white = 'var(--white-0)',
  grey = 'var(--grey-500)',
  green = 'var(--t-green-500)',
  blue = 'var(--blue-500)',
}
